/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebremoverange3Inputs */

const en_placewebremoverange3 = /** @type {(inputs: Placewebremoverange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove hours`)
};

const de_placewebremoverange3 = /** @type {(inputs: Placewebremoverange3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeiten entfernen`)
};

/**
* | output |
* | --- |
* | "Remove hours" |
*
* @param {Placewebremoverange3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebremoverange3 = /** @type {((inputs?: Placewebremoverange3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebremoverange3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebremoverange3(inputs)
	return de_placewebremoverange3(inputs)
});
export { placewebremoverange3 as "placeWebRemoveRange" }